import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Image from '../Image';
import IconPlay from '../../../Icons/Play';
import { IconSize } from '../../../Icons/IconWrap';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import s from './Film.scss';
function formatDuration(duration) {
    if (duration === void 0) { duration = 0; }
    var date = new Date(0);
    date.setSeconds(duration);
    var timeStr = date.toISOString();
    var isLongerThanHour = date.getUTCHours() > 0;
    return isLongerThanHour ? timeStr.substr(11, 8) : timeStr.substr(14, 5);
}
var FilmDumbView = function (props) {
    var width = props.width, className = props.className, deviation = props.deviation;
    var isLessThanMinWidth = (width || 0) < 250;
    var media = DeviationMediaService.getMediaByType(deviation, 'video');
    var videoFile = (media && media.find(function (f) { return f.type === 'video'; })) || {
        duration: 0,
    };
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(s['overlay'], isLessThanMinWidth && s['small']) },
            React.createElement("div", { className: s['controls'] },
                React.createElement("div", { className: s['icon'] },
                    React.createElement("span", { className: s['icon-button'] },
                        React.createElement(IconPlay, { size: IconSize.SMALL }))),
                React.createElement("div", { className: s['duration'], title: "duration" }, formatDuration(videoFile.duration)))),
        React.createElement(Image, __assign({}, props))));
};
export default FilmDumbView;
//# sourceMappingURL=Film.js.map